import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { Button } from "../components/ui/button";

// PROPERTY PHOTOS - Replace empty arrays with actual photo URLs after upload
// Each property has a specific number of photo slots as specified
const properties = [
  {
    id: 1,
    title: "Rare maison en plein cœur des Batignolles",
    location: "Paris 17ème",
    status: "Trouvé",
    type: "Maison",
    rooms: 5,
    bedrooms: 3,
    bathrooms: 2,
    wc: 3,
    surface: 110,
    images: [
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736517/00_salle_a%CC%80_manger_scdcbf.webp",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736517/01__z2_kcuxv9.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736517/02_salon_njsxp5.webp",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736517/02_salon_2_efhwkd.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736517/03_suite_parentale_pfgoiv.webp",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736517/03_cuisine_un1jvh.webp",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736517/04_suite_parentale_2_efzypg.webp",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736517/05_salle_de_bain_1_web4kq.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736518/07_chambre_2_gfsx37.webp",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736518/081_20221012_084630_aevrnb.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736518/082_20220905_120040_whyqyi.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736518/082_de%CC%81tail_3_e47nm6.webp",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736518/083_entre%CC%81e_1_dsubes.jpg"
    ],
    totalSlots: 13
  },
  {
    id: 2,
    title: "Appartement haussmannien à deux pas du Sacré-Cœur",
    location: "Montmartre, Paris 18ème",
    status: "Trouvé",
    type: "Appartement",
    rooms: 3,
    bedrooms: 2,
    bathrooms: 1,
    surface: 70,
    images: [
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997135/1_salon1cap_gloscr.png",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997135/2_salon2cap_bkgv3v.png",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997132/3_salon3_ii3ayy.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997132/4_salon4_s0q56e.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997133/5_chambre11_hifwwz.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997133/6_chambre13_wvksis.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997135/7_chambre21_wsbtm7.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997133/8_couloir_sokkyt.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1779997134/9_sdb1_wwests.jpg"
    ],
    totalSlots: 9
  },
  {
    id: 3,
    title: "Duplex atypique dans le Marais",
    location: "Paris 2ème",
    status: "Trouvé",
    type: "Duplex",
    rooms: 4,
    bedrooms: 2,
    bathrooms: 1,
    surface: 83,
    images: [
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736900/01_IMG_6098_Original_ibnrsb.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736902/02_IMG_6104_Original_lvj01k.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736899/03_IMG_6101_Original_lu0ua1.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736906/05_IMG_6089_Original_htdk3w.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736906/05_IMG_6089_Original_htdk3w.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736898/07_IMG_6105_Original_kfbsey.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736907/08_IMG_6091_Original_m3epao.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736897/09_IMG_6090_Original_boznaz.jpg"
    ],
    totalSlots: 8
  },
  {
    id: 4,
    title: "Appartement rénové à Montmartre",
    location: "Paris 9ème",
    status: "Vendu",
    type: "Appartement",
    rooms: 3,
    bedrooms: 2,
    bathrooms: 1,
    surface: 79,
    images: [
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736824/01_Image_03-02-2025_at_16.37_8_atknrm.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736825/02_Image_03-02-2025_at_16.37_10_pdoq9y.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736826/03_Image_03-02-2025_at_16.37_7_zsrp7x.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736825/04_Image_03-02-2025_at_16.37_12_iuacmq.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736829/05_Image_03-02-2025_at_16.37_11_dsq4ml.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736827/06_Image_03-02-2025_at_16.37_xuhj6l.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736830/07_Image_03-02-2025_at_16.37_4_tuxxqb.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736828/08_Image_03-02-2025_at_16.37_5_vwioc0.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736830/09_Image_03-02-2025_at_16.37_13_vhh2ni.jpg",
      "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736831/091_Image_03-02-2025_at_16.37_14_zqmime.jpg"
    ],
    totalSlots: 10
  }
];

// Property Card Component with Gallery
const PropertyCard = ({ property, index }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showGallery, setShowGallery] = useState(false);
  
  // Filter non-null images for gallery
  const availableImages = property.images.filter(img => img !== null);
  const hasImages = availableImages.length > 0;

  const nextImage = (e) => {
    e.stopPropagation();
    if (availableImages.length > 1) {
      setCurrentImageIndex((prev) => (prev + 1) % availableImages.length);
    }
  };

  const prevImage = (e) => {
    e.stopPropagation();
    if (availableImages.length > 1) {
      setCurrentImageIndex((prev) => (prev - 1 + availableImages.length) % availableImages.length);
    }
  };

  return (
    <>
      <motion.div
        id={`property-${property.id}`}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        data-testid={`property-${property.id}`}
        className="bg-white border border-line overflow-hidden group shadow-sm scroll-mt-40"
      >
        {/* Main Image */}
        <div 
          className="relative aspect-[16/10] overflow-hidden cursor-pointer"
          onClick={() => hasImages && setShowGallery(true)}
        >
          {hasImages ? (
            <>
              <img
                src={availableImages[currentImageIndex]}
                alt={property.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {availableImages.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 p-2 rounded-full text-white transition-colors"
                  >
                    <ChevronLeft size={20} />
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 p-2 rounded-full text-white transition-colors"
                  >
                    <ChevronRight size={20} />
                  </button>
                  <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
                    {availableImages.map((_, idx) => (
                      <div
                        key={idx}
                        className={`w-2 h-2 rounded-full transition-colors ${
                          idx === currentImageIndex ? 'bg-gold' : 'bg-white/50'
                        }`}
                      />
                    ))}
                  </div>
                </>
              )}
            </>
          ) : (
            <div className="w-full h-full bg-surface flex flex-col items-center justify-center">
              <p className="font-serif text-text-muted italic">Image à uploader</p>
            </div>
          )}
          <div className="absolute top-4 left-4">
            <span className={`px-4 py-2 text-xs font-semibold uppercase tracking-widest ${
              property.status === "Trouvé" 
                ? "bg-gold text-white" 
                : "bg-navy text-white"
            }`}>
              {property.status}
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="p-8">
          <h2 className="font-serif text-2xl text-text-primary mb-3">
            {property.title}
          </h2>
          <div className="text-text-secondary mb-5 text-sm uppercase tracking-widest">
            {property.location}
          </div>

          {/* Specs */}
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-text-secondary">
            <span>{property.rooms} pièces</span>
            <span className="text-line">|</span>
            <span>{property.bedrooms} chambres</span>
            {property.bathrooms && (
              <>
                <span className="text-line">|</span>
                <span>{property.bathrooms} sdb</span>
              </>
            )}
            <span className="text-line">|</span>
            <span>{property.surface} m²</span>
          </div>

          {/* Photo Count - removed per user request */}
        </div>
      </motion.div>

      {/* Full Gallery Modal */}
      {showGallery && hasImages && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center"
          onClick={() => setShowGallery(false)}
        >
          <button 
            className="absolute top-4 right-4 text-white hover:text-gold transition-colors"
            onClick={() => setShowGallery(false)}
          >
            <X size={32} />
          </button>
          
          <button
            onClick={(e) => { e.stopPropagation(); prevImage(e); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 p-4 rounded-full text-white transition-colors"
          >
            <ChevronLeft size={32} />
          </button>
          
          <img
            src={availableImages[currentImageIndex]}
            alt={property.title}
            className="max-w-[90vw] max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          
          <button
            onClick={(e) => { e.stopPropagation(); nextImage(e); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 p-4 rounded-full text-white transition-colors"
          >
            <ChevronRight size={32} />
          </button>
          
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white">
            {currentImageIndex + 1} / {availableImages.length}
          </div>
        </div>
      )}
    </>
  );
};

export const NosTrouvaillesPage = () => {
  const [filter, setFilter] = useState("all");
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Delay to allow render + images to layout, then scroll to the anchored card
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  const filteredProperties = properties.filter(property => {
    if (filter === "all") return true;
    return property.status === filter;
  });

  return (
    <div data-testid="nos-trouvailles-page" className="pt-32">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <p className="text-gold text-sm font-bold uppercase tracking-[0.2em] mb-4">
              Notre portfolio
            </p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
              Nos trouvailles
            </h1>
            <p className="text-text-secondary text-lg">
              Découvrez une sélection de biens que nous avons trouvés ou vendus pour nos clients
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filter */}
      <section className="py-8 bg-surface border-y border-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex justify-center gap-4">
            <Button
              data-testid="filter-all"
              variant={filter === "all" ? "default" : "outline"}
              onClick={() => setFilter("all")}
              className={filter === "all" 
                ? "bg-navy text-white hover:bg-navy border-navy rounded-none" 
                : "border-navy text-navy hover:bg-navy hover:text-white rounded-none"
              }
            >
              Tous
            </Button>
            <Button
              data-testid="filter-trouve"
              variant={filter === "Trouvé" ? "default" : "outline"}
              onClick={() => setFilter("Trouvé")}
              className={filter === "Trouvé" 
                ? "bg-navy text-white hover:bg-navy border-navy rounded-none" 
                : "border-navy text-navy hover:bg-navy hover:text-white rounded-none"
              }
            >
              Trouvé
            </Button>
            <Button
              data-testid="filter-vendu"
              variant={filter === "Vendu" ? "default" : "outline"}
              onClick={() => setFilter("Vendu")}
              className={filter === "Vendu" 
                ? "bg-navy text-white hover:bg-navy border-navy rounded-none" 
                : "border-navy text-navy hover:bg-navy hover:text-white rounded-none"
              }
            >
              Vendu
            </Button>
          </div>
        </div>
      </section>

      {/* Properties Grid */}
      <section data-testid="properties-grid" className="py-16 md:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {filteredProperties.map((property, index) => (
              <PropertyCard key={property.id} property={property} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* Upload Instructions - removed per user request */}
    </div>
  );
};
